import * as React from 'react';
import { processJSXText, ReplaceComponentType } from './unified';
type L10NContext = {
  language: LanguageType;
  messages: Record<string, string>;
  t: (key: string, components?: Record<string, ReplaceComponentType>) => string | React.ReactNode;
};

export type LanguageType = 'ko' | 'en' | 'ja' | 'zh-Hant' | 'zh-Hans' | 'th';

export const l10nContext = React.createContext<L10NContext | null>(null);

export const useL10N = () => {
  const l10n = React.useContext(l10nContext);
  if (!l10n) {
    throw new Error(
      '지역화 리소스를 찾을 수 없습니다.\n\n' +
        '작업 중인 페이지에 다음과 같이 페이지 쿼리를 추가하세요.\n' +
        'const query = graphql`\n' +
        '    query MyPage($translationId: String!) {\n' +
        '        ...TranslationMessages\n' +
        '    }\n' +
        '`',
    );
  }
  return l10n;
};

export function getTranslationText(
  l10n: {
    language: LanguageType;
    messages: Record<string, string>;
  },
  key: string,
  components?: Record<string, ReplaceComponentType>,
) {
  const _text = l10n.messages[key] ?? '⚠️⚠️⚠️';
  if (!(_text.includes('<') && _text.includes('>'))) {
    return _text;
  }
  return processJSXText(_text, components);
}

export function useLanguage() {
  return useL10N().language;
}

export const useTranslation = () => {
  const l10n = useL10N();
  return l10n.t;
};
